module.exports = __webpack_public_path__ + "static/media/hamburger.18481d78.svg";